// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:17:46+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1c9859b510ac48f1c64e39dd54942eec
//    Signature:      eyJpdiI6Ik1sVVpiVk53M2ZsN1NpbmpQNFR6RGc9PSIsInZhbHVlIjoiK1wvSG8rUlVPam9BQXFUT05YWmxjZW5LN3lhaDl0a2I2XC81YnpwbkxSR2JXZk9kTnBMM2dhMFBEXC9wMFZhRTBTb3R1XC9xT1wveDNpS2lkVldSZERuQUJtd2FWMEZvSms1emMwaVRUZWs3QjYxRWZ4WlwvMEtuMVZIZVhrbnNQTjJvR0NsNElNcTNBU0tBTjZ4NVJjU0N4c1FwcXdDajJyaXRFXC9sOTdlS1wvbmhKeEtwTnk2MUpEOHpMMGhkZHYwOUFDcU9UT2xJWlJtVThPRXd6RXJiaVYzWVJQOGpQbVE0b25wNWFoZVZEcFJGa3o3RElkaDZzZFhLeE5GcXdzcEpiallFNUNSeUk0S29hVmZrR1c4SHhnUkE0SGt1Y2YweUVhbEV3Z05yOWdtdkVBZWFGTDR5akt6aEY4ak5iRGVzeHBMQXZHU2NsQU1idW9ZMGtDTGgweWJDNTdIdHB3ZDNLaDh3cmxBZGlUMFlSb1ZGdWNIRjFvaDcxSlwvSjRDSW5vXC91KzFxQ2pVWDlpVnRqdHM3UVg3MTlUWFE9PSIsIm1hYyI6IjljNGZiMDQxOTI5MzgzZjJmYjNmNWE3MTg2ZTg3ZDI0ZDI0YzFjNDhkN2Q5NmZkOTE2Mzc5YjFkNDQ5OWNmMGIifQ==
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
